import { configureDevAlerts } from '@sbercloud/ft-debug-mode';
import { AnalyticsClient } from './AnalyticsClient';
import { GoogleAnalyticsClient } from './GoogleAnalyticsClient';
import { YandexMetricaClient } from './YandexMetricaClient';
const convertJsonToString = (obj) => JSON.stringify(obj, null, 2);
export class CloudMetricClient {
    constructor({ yandexMetricaIds, googleAnalyticsId, submitAnalyticsEventHandler, nonceId, loggingEnabled = true, }) {
        this.clients = [];
        this.initialize = () => {
            this.logger.info(`initialized`);
            this.clients.forEach(client => client.initialize());
        };
        this.sendEvent = (eventDefinition, meta) => {
            this.logger.info(`sendEvent, event definition: ${convertJsonToString(eventDefinition)}, meta: ${convertJsonToString(meta)}`);
            this.clients.forEach(client => client.sendEvent(eventDefinition, meta));
        };
        this.pageVisited = (eventDefinition, meta) => {
            this.logger.info(`pageVisited`);
            this.clients.forEach(client => client.pageVisited(eventDefinition, meta));
        };
        this.sendCommonEvent = (entity, action, meta) => {
            this.logger.info(`sendCommonEvent, entity: ${entity}, action: ${action}, meta: ${convertJsonToString(meta)}`);
            this.clients.forEach(client => client.sendEvent({ category: 'common', entity, action }, meta));
        };
        yandexMetricaIds === null || yandexMetricaIds === void 0 ? void 0 : yandexMetricaIds.forEach(yandexMetricaId => this.clients.push(new YandexMetricaClient(yandexMetricaId, nonceId)));
        this.clients.push(new GoogleAnalyticsClient(googleAnalyticsId, nonceId));
        if (submitAnalyticsEventHandler) {
            this.clients.push(new AnalyticsClient(submitAnalyticsEventHandler));
        }
        this.logger = configureDevAlerts({ scope: 'Metric Client', enabled: loggingEnabled });
    }
}
